var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoginCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 0.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5C11.3137 14.5 14 11.8137 14 8.5C14 5.18629 11.3137 2.5 8 2.5C4.68629 2.5 2 5.18629 2 8.5C2 11.8137 4.68629 14.5 8 14.5Z",
    stroke: "url(#paint0_linear_1276_188329)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3536 7.52152C10.5488 7.32626 10.5488 7.00968 10.3536 6.81442C10.1583 6.61915 9.84171 6.61915 9.64645 6.81442L10.3536 7.52152ZM7.33333 9.83464L6.97978 10.1882C7.17504 10.3835 7.49162 10.3835 7.68689 10.1882L7.33333 9.83464ZM6.35355 8.14775C6.15829 7.95249 5.84171 7.95249 5.64645 8.14775C5.45118 8.34301 5.45118 8.65959 5.64645 8.85486L6.35355 8.14775ZM9.64645 6.81442L6.97978 9.48108L7.68689 10.1882L10.3536 7.52152L9.64645 6.81442ZM7.68689 9.48108L6.35355 8.14775L5.64645 8.85486L6.97978 10.1882L7.68689 9.48108Z",
    fill: "url(#paint1_linear_1276_188329)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1276_188329",
    x1: 14,
    y1: 2.5,
    x2: 2,
    y2: 14.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#659C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428B51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1276_188329",
    x1: 10,
    y1: 7.16797,
    x2: 7.53846,
    y2: 10.8603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#659C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428B51"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginCompleted);
export default __webpack_public_path__ + "static/media/login-completed.fb61af8775ed3044f58b820d9b69f77c.svg";
export { ForwardRef as ReactComponent };